import React from "react";
import SelectableList from "./SelectableList";
import { useAppContext } from "../../helpers/account-context";
import { cleanAvailableTypes } from "../../helpers/helper";

const TypeSelector = (props) => {
  const { filters, onChangeFilters } = props;
  // https://codepen.io/smithsuth/pen/VvYzZP
  const { initedData: {enabledTypes, hiddenFilters}, account: { location_types }, getLocale } = useAppContext()
  const isHidden = !!hiddenFilters && (hiddenFilters.indexOf('types') >= 0 || hiddenFilters.indexOf('all') >= 0);
        
  if(isHidden) return null;
            
  const typeOptions = cleanAvailableTypes(location_types, enabledTypes);
  if(!typeOptions || typeOptions.length === 0) return null;

  return  (
    <SelectableList
      title={getLocale("location_type")}
      items={typeOptions}
      selectedItems={!!filters.location_type_id ? [filters.location_type_id] : []}
      isMulti={false}
      onChange={(newTypes) => {
        return onChangeFilters({ 
          ...filters, 
          location_type_id: newTypes && newTypes.length > 0 ? newTypes[0] : ''
        })
      }}
    />
  )
};

export default TypeSelector;
